import { get, post, del } from './http'
// 登陆
export const api_login = params => post('/api/student/login', params)
// 刷新token
export const api_refreshToken = params => post('/api/student/refresh_token', params)

/**
 * 首页
 */
// 待选课
export const api_canChoose = page => get(`/api/course/canChoose?page=${page}&pageSize=50`)
// 待预考核
export const api_preCheck = () => get(`/api/chapter/pre_exam`)
// 待预约
export const api_order = () => get(`/api/chapter/reservation/index`)
// 待上课
export const api_waitToClass = () => get(`/api/student/chapter/waitToChapter`)
// 通知
export const api_news = p => get(`/api/notices/index/?page=${p}`)
// 通知详情
export const api_newsDetail = id => get(`/api/notices/detail/${id}`)

/**
 * 选课
 */
// 选课详情
export const api_classDetail = id => get(`/api/course/detail/${id}`)
// 选课
export const api_selectClass = id => post(`/api/course/select?course_id=${id}`)
// 实验详情
export const api_projectDetail = id => get(`/api/student/chapter/detail/${id}`)
// 预考核题目
export const api_questions = id => get(`/api/chapter/generateQuestions/${id}`)
// 提交答案
export const api_submitAnswer = params => post(`/api/chapter/submitPreExamQuestion`, params)
// 预约详情
export const api_orderDetail = id => get(`/api/chapter/reservation/detail/${id}`)
// 发起预约
export const api_toOrder = params => post(`/api/chapter/reservation`, params)
// 取消预约
export const api_cancelOrder = params => post('/api/chapter/reservation_cancel', params)
// 获取实验台数
export const api_sitNumber = params => post(`/api/chapter/reservation/detail/get_left_sit`, params)
/**
 * 我的
 */
// 学生信息
export const api_studentInfo = () => get('/api/student/base_info')
// 待评价列表
// export const api_evaluation = () => get('/api/teacher_course/evaluation')
export const api_evaluation = () => get('/api/course/score/index')
// 评教题目
export const api_evaluationQestion = id => get(`/api/teacher_course/evaluation/${id}`)
// 提交评教
export const api_confirmEvaluation = params => post('/api/teacher_course/evaluation', params)
// 我的课表
export const api_scheduleList = status => get(`/api/student/myCourseList/${status}`)
// 我的课程
export const api_classList = status => get(`/api/student/myCourse/${status}`)
// 我的补考
export const api_makeup = () => get('/api/student/course/makeup/index')
// 补考项目
export const api_makeupItem = id => get(`/api/student/course/chapter/makeup/${id}`)
// 补考详情
export const api_makeupProjectDetail = id => get(`/api/student/course/makeup/detail/${id}`)
// 补考预约详情
export const api_makeupDetail = id => get(`/api/student/course/makeup/selectDateBatch/${id}`)
// 发起补考预约
export const api_makeupOrder = params => post('/api/student/course/makeup/store', params)
// 修改密码
export const api_changepass = params => post('/api/student/change_pass', params)

// 忽略课程
export const api_ignoreClass = params => post('/api/course/ignore', params)

//  发送短信验证码
export const api_verification_codes = (data) => post('/api/verification-codes', data)

//  绑定手机号
export const api_change_phone = (data) => post('/api/student/change_phone', data)

//  标题
export const api_get_title = () => get('/api/settings')



// 我的实习-列表
export const api_sxCourse_list = () => get('/api/student/sxCourse')

// 我的实习-详情
export const api_sxCourse_Detail = (sx_course_id) => get(`/api/student/sxCourse/${sx_course_id}/scheme`)



// WEBPACK FOOTER //
// ./src/request/api.js